<template>
  <Grid
    :pageable="false"
    :resizable="true"
    :reorderable="true"
    :sortable="false"
    :row-height="25"
    :data-items="selectedVendors"
    :columns="prepareColumnsData({ initialColumns: fields, settingsColumns: gridSettings.columns })"
    @columnresize="handleColumnResize"
    @columnreorder="handleColumnReorder"
    class="grid"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import debounce from 'lodash/debounce';

import { GRID_ID, SAVE_SETTINGS_DELAY } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';

import fields from './fields';

export default {
  data: () => ({
    prepareColumnsData,
    fields,
  }),
  computed: {
    ...mapGetters('rfps', ['selectedRfpId']),
    ...mapGetters('rfpSelectedVendors', ['selectedVendors']),
    ...mapGetters('account', ['gridSettingsById']),
    gridId() {
      return GRID_ID.RFP_GRID_VENDORS;
    },
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
  },
  methods: {
    ...mapActions('rfpSelectedVendors', ['getSelectedVendors']),
    ...mapActions('account', ['saveGridSettings']),
    handleColumnResize: debounce(function ({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: fields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({
        id: this.gridId,
        settings: { columns: newColumns },
      });
    }, SAVE_SETTINGS_DELAY),
    handleColumnReorder({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: fields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({
        id: this.gridId,
        settings: { columns: newColumns },
      });
    },
  },
  watch: {
    selectedRfpId() {
      this.getSelectedVendors(this.selectedRfpId);
    },
  },
  mounted() {
    this.getSelectedVendors(this.selectedRfpId);
  },
};
</script>

<style scoped>
.grid {
  max-height: 300px;
}
</style>
